import React from "react";
import PropTypes from "prop-types";

import styles from "./Aside.module.css";

export default function Aside({ children }) {
  if (!children) return null;

  return <aside className={styles.aside}>{children}</aside>;
}

Aside.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
